import {
  STANDARD_NUMBER_WIDTH,
  STANDARD_NUMBER_HEIGHT,
  LARGE_NUMBER_HEIGHT,
  LARGE_NUMBER_WIDTH,
} from '@Animation/constants'
import {
  PLUS_3_ANIMATION_ATLAS_FRAMES,
  PLUS_3_STANDARD_ATLAS_FRAMES,
  PLUS_3_TEXTURE_KEYS,
} from './constants'
import { ANIMATION_IDENTIFIERS } from '@Animation/types'

export const getPlus3TextureLoader = (identifier: ANIMATION_IDENTIFIERS) => {
  return (scene: Phaser.Scene) => {
    if (
      !scene.textures
        .getTextureKeys()
        .includes(`${PLUS_3_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED}${identifier}`)
    ) {
      scene.textures.addSpriteSheetFromAtlas(
        `${PLUS_3_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED}${identifier}`,
        {
          atlas: PLUS_3_TEXTURE_KEYS.STANDARD_ATLAS,
          frame: PLUS_3_STANDARD_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED,
          frameWidth: STANDARD_NUMBER_WIDTH,
          frameHeight: STANDARD_NUMBER_HEIGHT,
        },
      )
    }

    if (
      !scene.textures.getTextureKeys().includes(`${PLUS_3_TEXTURE_KEYS.NUMBER_HIT}${identifier}`)
    ) {
      scene.textures.addSpriteSheetFromAtlas(`${PLUS_3_TEXTURE_KEYS.NUMBER_HIT}${identifier}`, {
        atlas: `${PLUS_3_TEXTURE_KEYS.ANIMATION_ATLAS}${identifier}`,
        frame: PLUS_3_ANIMATION_ATLAS_FRAMES.NUMBER_HIT,
        frameWidth: STANDARD_NUMBER_WIDTH,
        frameHeight: STANDARD_NUMBER_HEIGHT,
      })
    }
    if (
      !scene.textures
        .getTextureKeys()
        .includes(`${PLUS_3_TEXTURE_KEYS.NUMBER_HIT_TRANSITION}${identifier}`)
    ) {
      scene.textures.addSpriteSheetFromAtlas(
        `${PLUS_3_TEXTURE_KEYS.NUMBER_HIT_TRANSITION}${identifier}`,
        {
          atlas: `${PLUS_3_TEXTURE_KEYS.ANIMATION_ATLAS}${identifier}`,
          frame: PLUS_3_ANIMATION_ATLAS_FRAMES.NUMBER_HIT_TRANSITION,
          frameWidth: LARGE_NUMBER_WIDTH,
          frameHeight: LARGE_NUMBER_HEIGHT,
        },
      )
    }
    if (
      !scene.textures
        .getTextureKeys()
        .includes(`${PLUS_3_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION}${identifier}`)
    ) {
      scene.textures.addSpriteSheetFromAtlas(
        `${PLUS_3_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION}${identifier}`,
        {
          atlas: PLUS_3_TEXTURE_KEYS.STANDARD_ATLAS,
          frame: PLUS_3_STANDARD_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED_TRANSITION,
          frameWidth: LARGE_NUMBER_WIDTH,
          frameHeight: LARGE_NUMBER_HEIGHT,
        },
      )
    }
  }
}
